import * as requestshrActionCreators from '../../../redux/modules/requests-hr';
import * as authActions from "../../../redux/modules/auth";

const mapStateToProps = state => ({
  selectedRequests: state.requestsForHr.selectedRequests,
  pageCount: state.requestsForHr.pageCount,
  requestStore: state.requestsForHr.requests,
  isActive: state.auth.isActive,
});

const mapDispatchToProps = {
  ...requestshrActionCreators,
  ...authActions,
};

export default [mapStateToProps, mapDispatchToProps];



// WEBPACK FOOTER //
// ./src/containers/hr/request-page/index.js